import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./locales/en.json";
import ar from "./locales/ar.json";
import ur from "./locales/ur.json";
import fr from "./locales/fr.json";

const resources: Record<string, Record<string, any>> = {
  en: { translation: en },
  ar: { translation: ar },
  ur: { translation: ur },
  fr: { translation: fr },
};

i18n.use(initReactI18next).init({
  resources,
  fallbackLng: "en",
  debug: false,
  interpolation: {
    escapeValue: false,
  },
});

export const i18n1 = i18n;
